(() => {
  const openBtn = document.querySelector("[data-v-open-menu]");
  const closeBtn = document.querySelector("[data-v-close-menu]");
  const nav = document.querySelector("[data-v-mobile-nav]");
  if (!nav || !openBtn) return;

  const setOpen = (open) => {
    nav.classList.toggle("is-open", open);
    openBtn.classList.toggle("is-open", open);
    openBtn.setAttribute("aria-expanded", open ? "true" : "false");
    nav.setAttribute("aria-hidden", open ? "false" : "true");
    document.body.style.overflow = open ? "hidden" : "";
  };

  openBtn.addEventListener("click", (e) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen(!nav.classList.contains("is-open"));
  });
  closeBtn?.addEventListener("click", (e) => {
    e.preventDefault();
    setOpen(false);
  });
  nav.querySelectorAll("a[data-v-close-menu]").forEach((el) => {
    el.addEventListener("click", () => setOpen(false));
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") setOpen(false);
  });
})();
